export const POST = "/post";
export const USER = "/user";
export const HOME = "/"
